import { useEffect, useState } from "react";

export type Size = {
    sm: boolean;
    md: boolean;
    lg: boolean;
    xl: boolean;
    "2xl": boolean;
};

type WindowDimensions = {
    width: number;
    height: number;
    size: Size;
};

function getWindowDimensions(): WindowDimensions {
    const { innerWidth: width, innerHeight: height } = window;

    const size: Size = {
        sm: false,
        md: false,
        lg: false,
        xl: false,
        "2xl": false,
    };
    if (width >= 640) size.sm = true;
    if (width >= 768) size.md = true;
    if (width >= 1024) size.lg = true;
    if (width >= 1280) size.xl = true;
    if (width >= 1536) size["2xl"] = true;

    return {
        width,
        height,
        size,
    };
}

export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
}
